import(/* webpackMode: "eager" */ "/vercel/path0/app/about/blog/page.tsx");
